module.exports = __webpack_public_path__ + "media/images/icons/facebook_dark-887d94a76f8ed918cc3fa497a592b337.svg";